import React from "react";

import Button from "../../../Button";
import Modal from "../../Modal";

import { useUserManagementTranslation, UserManagementResource } from "./useUserManagementTranslation";

import style from "./styles.module.scss";

const keyI18n = "translations.admin.users.confirm";

export type ConfirmAction = "deactivate" | "reactivate";

interface Props {
  resource: UserManagementResource;
  action: ConfirmAction | null;
  name: string;
  busy: boolean;
  failed: boolean;
  onCancel(): void;
  onConfirm(): void;
}

export default function ConfirmDialog({ resource, action, name, busy, failed, onCancel, onConfirm }: Props) {
  const { t } = useUserManagementTranslation(resource);

  if (!action) {
    return null;
  }

  return (
    <Modal
      open
      onClose={busy ? () => undefined : onCancel}
      dismissible={!busy}
      icon={action === "deactivate" ? "person_off" : "person_check"}
      title={t(`${keyI18n}.${action}.title`, { name })}
      size="small"
      actions={(
        <>
          <Button variant="text" size="small" onClick={onCancel} disabled={busy}>
            {t(`${keyI18n}.cancel`)}
          </Button>
          <Button variant="filled" size="small" onClick={onConfirm} disabled={busy} softDisabled={busy}>
            {t(`${keyI18n}.${action}.confirm`)}
          </Button>
        </>
      )}
    >
      <p className="pgm-body-medium">{t(`${keyI18n}.${action}.description`)}</p>
      {failed && (
        <p className={`pgm-body-medium ${style.formError}`} role="alert">
          {t(`${keyI18n}.error`)}
        </p>
      )}
    </Modal>
  );
}
